import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SEO_CONFIG } from "./seo-inject";
import { seoConfig } from 'src/app/shared/interfaces/index.interface';

@NgModule({
  imports: [CommonModule]
})
export class SeoModule {
  public static forRoot(config: seoConfig): ModuleWithProviders<SeoModule> {
    return {
      ngModule: SeoModule,
      providers: [{ provide: SEO_CONFIG, useValue: config }],
    };
  }
}